import api, { queryClient } from "../../api";
import ENDPOINTS from "../../api/endpoints";
import QUERYKEYS from "../../api/queryKeys";
import UserAuthStore from "../../store/userStore";
import useSessionIdStore from "../../store/useSessionIdStore";
import logger from "../../services/Logger";
import { broadcastInvalidate } from "../../api/broadcastSync";

/**
 * Optimistically toggle the pinned state of a Spectra space and sync to backend.
 *
 * @param {string} spaceId  - Spectra space_id
 * @param {string} ownerId  - Space owner's uid
 * @param {boolean} value   - New pin value (true = pin, false = unpin)
 */
export const pinSpectraAPI = async (spaceId, ownerId, value) => {
  const { user, orgId } = UserAuthStore.getState();
  const queryKey = [QUERYKEYS.SPECTRAS, orgId, user?.uid];

  // Optimistic update — flip pinned in the cache immediately
  const previousData = queryClient.getQueryData(queryKey);
  queryClient.setQueryData(queryKey, (old) => {
    if (!Array.isArray(old)) return old;
    return old.map((s) =>
      s.space_id === spaceId ? { ...s, pinned: value } : s
    );
  });

  try {
    const session_id = useSessionIdStore.getState().session_id;
    await api({
      method: "POST",
      url: ENDPOINTS.PIN_SPECTRA,
      data: {
        space_id: spaceId,
        org_id: orgId,
        user_id: user?.uid,
        owner_id: ownerId,
        pin_value: value,
        session_id,
      },
    });
    broadcastInvalidate(queryKey);
  } catch (error) {
    // Rollback on failure
    queryClient.setQueryData(queryKey, previousData);
    logger.error("pinSpectraAPI", "Error updating pin status", {
      err: error?.message,
      space_id: spaceId,
      pinned: value,
      orgId,
    });
  }
};
